<template>
        <div id="contenedor-pasoUno" class="col-4 padding-div-low">
            <div class="area">
                <div id="subidordearchivos_div text-left">
                    <h5>Paso 1: Seleccione micrositio,página y sección</h5>
                    <hr />
                    <div>
                        <h6 style="padding: 5px">Micrositio</h6>
                        <C001PaginaInicio   v-on:valorParaElPadre="cambioTipoDePagina" :prefijo="enumeraciones.etiquetasDeHTML.Select" :tipo="enumeraciones.tiposDeSelect.Seleccione" :idDelInput="'catalogoPaginaPasoUno'" :parametros="{PaginaDeInicioId: null,MenuId: null,SubmenuId: null,TipoContenedorId: null,ConPaginaDeInicio: false,ConMenu: false,ConSubmenu: false, ConSecciones: false, ConInactivas:false, SoloPermiteSubirContenido: true}" :valorDefinido="tipoDePaginaWebId"></C001PaginaInicio>
                        <h6 v-if="obtenerCatalogoPaginasDeMicrositio.catalogoPaginaPasoUno >= 0" style="padding: 5px">Página&nbsp;<i style="cursor: pointer" class="fas fa-info-circle" @click="mostrarMensajeSecciones"></i></h6>
                        <div id="pasoUno-aviso-secciones" v-if="mostarAvisoSecciones && obtenerCatalogoPaginasDeMicrositio.catalogoPaginaPasoUno >= 0">
                            <h6><i class="fas fa-info-circle"></i>&nbsp;Nota</h6>
                            <span style="text-align: justify; display:block;">{{MENSAJE_AVISO_SECCIONES}}</span>
                        </div>
                        <C013PaginasMicrositio v-if="mostrarPaginasDeMicrositio"  style="padding:0; margin:0;" v-on:valorParaElPadre="cambioTipoDeMicrositio" :prefijo="enumeraciones.etiquetasDeHTML.Select" :tipo="enumeraciones.tiposDeSelect.Seleccione" :idDelInput="'catalogoPaginaMicrositioPasoUno'" :parametros="{PaginaMicrositioId:null,PaginaDeInicioId: idMicrositio,MenuId: null,SubmenuId: null,SeccionDeMicrositioId: null,ConSecciones:false,ConPaginaDeInicio: false,ConTipoContenedor: false,ConInactivas:false,FiltrarPorUsuario:true}" :valorDefinido="-1" :key="idMicrositio+'|M'"></C013PaginasMicrositio>
                        <h6 v-if="obtenerCatalogoSeccion.catalogoPaginaMicrositioPasoUno > 0 && mostrarSelectSeccion==true"  style="padding: 5px; margin-top: 20px;">Sección</h6>
                        <C014SeccionesDelMicrositio v-if="obtenerCatalogoSeccion.catalogoPaginaMicrositioPasoUno > 0 && mostrarSelectSeccion==true" style="padding:0; margin:0;" v-on:valorParaElPadre="cambioTipoSeccion" :prefijo="enumeraciones.etiquetasDeHTML.Select" :tipo="enumeraciones.tiposDeSelect.Seleccione" :idDelInput="'catalogoSeccionPasoUno'" :parametros="{PaginaMicrositioId: idPaginaMicrositio,SeccionMicrositioId:null, TipoFormatoId: null, ConActivo: true, ConContenido:false,ConTipoFormato:true}" :valorDefinido="-1" :key="idPaginaMicrositio"></C014SeccionesDelMicrositio>
                        <div v-if="mostrarSubsecciones" style="margin-top: 20px;">
                        <h6 style="padding: 5px; margin-top: 20px;">SubSección</h6>
                        <CSelectGenerico v-on:valorParaElPadre="cambioSubSeccion"  :prefijo="enumeraciones.etiquetasDeHTML.Select" :tipo="enumeraciones.tiposDeSelect.Seleccione" :idDelInput="'1'" :valorDefinido="-1" :elementos="subSeccionesMicrositios" :mansajeValorDefinidoPlural="'las secciónes'" :mansajeValorDefinidoSingular="'un tipo de sección'"></CSelectGenerico>
                        
                        <div v-if="mostrarTablasDeSeccion">
                             <h6 style="padding: 5px; margin-top: 20px;">Tabla</h6>
                             <CSelectGenerico v-on:valorParaElPadre="cambioTablaMicrositio"  :prefijo="enumeraciones.etiquetasDeHTML.Select" :tipo="enumeraciones.tiposDeSelect.Seleccione" :idDelInput="'1'" :valorDefinido="-1" :elementos="tablasDeSeccion" :mansajeValorDefinidoPlural="'las secciónes'" :mansajeValorDefinidoSingular="'un tipo de sección'"></CSelectGenerico>
                        </div>
                        </div>
                    <h6 v-if="obtenerContenidoMicrositio.catalogoSeccionPasoUno > 0 && mostrarSelectCarrusel == true" style="padding: 5px">Carrusel</h6>

                   <C015SelectDelContenido v-if="obtenerContenidoMicrositio.catalogoSeccionPasoUno > 0 && mostrarSelectCarrusel == true"  style="padding:0; margin:0;" v-on:valorParaElPadre="cambioTipoCarrusel" :prefijo="enumeraciones.etiquetasDeHTML.Select" :tipo="enumeraciones.tiposDeSelect.Seleccione" :idDelInput="'contenidoMicrositioId'" :parametros="{PaginaMicrositioId: null,SeccionMicrositioId:seccionId, TipoFormatoId: null, ConActivo: true, ConContenido:true,ConTipoFormato:false}" :valorDefinido="-1" :key="seccionId+'C'"></C015SelectDelContenido>
                        
                    </div>
                    <div v-if="mostrarSeccionSeleccionada">
                        <hr />
                        <p>Sección seleccionada: <span class="font-weight-bold">{{navegacionSecciones[navegacionSecciones.length -1]}}</span></p>
                        <hr />
                        <div class="text-right" style="margin-top: 20px;">
                            <div>
                                <button v-if="mostrarBotonDeAgregar" type="button" class="btn btn-primary" @click="comenzarCrearContenido"><i class="fas fa-plus-circle"></i>&nbsp;&nbsp;Agregar Contenido</button>
                            </div> 
                        </div> 
                    </div>
                </div>
            </div>
        </div>
</template>
<script>
  import catalogos from '@/../static/js/catalogos'
  import enumeraciones from '@/../static/js/enumeraciones'
  import formatos from '@/../static/js/enumeraciones/sicpo.js'
  import api from '@/../static/js/api'
  import comun from '@/../static/js/comun'
  import axios from 'axios'
  import CSelectGenerico from '@/components/SICPO/Comun/CSelectGenerico.vue'
  import C001PaginaInicio from '@/components/SICPO/Catalogos/C001PaginaInicio.vue'
  import C013PaginasMicrositio from '@/components/SICPO/Catalogos/C013PaginasMicrositio.vue'
  import C014SeccionesDelMicrositio from '@/components/SICPO/Catalogos/C014SeccionesDeMicrositio.vue'
  import C015SelectDelContenido from '@/components/SICPO/Catalogos/C015SelectContenidoMicrositio.vue'


  export default {
      data() {
          return {
            titulo: 'Alta de noticia',
            enumeraciones,
            idPaginaMicrositio:0,
            idMicrositio:0,
            seccionId:0,
            tipoDePaginaWebId: -1,
            tipoDeSeccionPaginaWeb: -1,
            numeroFormatoSeccion:-1,
            punteroDeContenidoActual: {
                paginaWebSeleccionada: '',
                rutaSecciones: '',
                seccionCrearContenidoId: -1
            },
            subSeccionesMicrositios:[],
            arbolSeccionesPaginaWeb: [],
            subseccionesDePagianWeb: [],
            contadorSubseccion: 0,
            seccionPadre: [],
            tablasDeSeccion:[],
            navegacionSecciones: [],
            punteroSeccionSeleccionada: '',
            mostrarSeccionSeleccionada: false,
            conCarrusel: false,
            mostrarSelectCarrusel:false,
            mostrarSelectSeccion:false,
            mostrarPaginasDeMicrositio:false,
            subseccionesAgregadasTmp: 0,
            mostarAvisoSecciones: false,
            mostrarSubsecciones:false,
            mostrarTablasDeSeccion:false,
            mostrarBotonDeAgregar:false,
            MENSAJE_AVISO_SECCIONES: 'Se le recuerda que sólo puede agregar contenido a las paginas a las que se le asignaron  permisos, si requiere un cambio de permisos por favor comuníquese a la Dirección de Informática.'
          }
      },
      components: {
         C013PaginasMicrositio,
         C014SeccionesDelMicrositio,
         C015SelectDelContenido,
         CSelectGenerico,
         C001PaginaInicio
      },
      methods: {
        mostrarMensajeSecciones: function() {
            if(!this.mostarAvisoSecciones){
                this.mostarAvisoSecciones = true;
            }
            else if (this.mostarAvisoSecciones) {
                this.mostarAvisoSecciones = false
            }
        },
        /**
         * Metodo encargado de obtener valores de la navegacion y del usuario entre las secciones, actualiza
         * en base de datos el valor enEdicion de la tabla seccionesDePaginaWeb indicando que la seccion se encuantra
         * en edicion.
         */
        comenzarCrearContenido: function() {
            
          //  this.punteroDeContenidoActual.rutaSecciones = this.navegacionSecciones.join('/');
            this.$store.dispatch("A_SICPO_PaginaWeb_AltaDeContenido_establecerPunteroDeContenidoActual",this.punteroDeContenidoActual);
               this.$store.dispatch("A_SICPO_PaginaWeb_AltaDeContenido_establecerMostrarFormularios",true);
                             $("#contenedor-pasoUno").addClass("desabilitar-div-pasoUno");
            //  console.log('valorPuntero::',this.punteroDeContenidoActual);
        },


/**
         * Metodo encargado de obtener el valor del item seleccionado en el catalogo 007PaginasWeb emitido por el componente
         * hijo que corresponde al catalogo y posteriormente construir el objeto de los campos que requerira el contenido.  
         * @see {@link identificarTipoDeFormulario}
         * @param {object} evento [evento emitido por el catalogo]
         */
        cambioTipoDePagina: function (evento) {
       //     console.log("Cambio TIpo de pagina:",this.obtenerCatalogoPaginasDeMicrositio.catalogoPaginaPasoUno)
            this.mostrarPaginasDeMicrositio = (this.obtenerCatalogoPaginasDeMicrositio.catalogoPaginaPasoUno>=0)?true:false;
            this.$store.dispatch("A_SICPO_PaginaWeb_AltaDeContenido_establecerCambioDeFormularioInput",true);
            this.idMicrositio = parseInt(this.$store.getters.Get_SICPO_Catalogos_001PaginaInicio.catalogoPaginaPasoUno);
            // console.log('valorDePaginaWebIdMicr::nuevo::' + this.idMicrositio);
            this.mostrarSelectSeccion=false;
            this.mostrarSelectCarrusel= false;
            this.mostrarSubsecciones = false;
            this.mostrarTablasDeSeccion=false;
        //     console.log("Cambio TIpo de pagina:",this.obtenerCatalogoPaginasDeMicrositio.catalogoPaginaPasoUno)
                      this.limpiarSubseccciones();
        },

        /**
         * Metodo encargado de obtener el valor del item seleccionado en el catalogo 007PaginasWeb emitido por el componente
         * hijo que corresponde al catalogo y posteriormente construir el objeto de los campos que requerira el contenido.  
         * @see {@link identificarTipoDeFormulario}
         * @param {object} evento [evento emitido por el catalogo]
         */
        
        cambioTipoDeMicrositio: function (evento) {                    
                this.validarSeccionesNoValidas(evento.target.value,this.seccionPadre);  
                     this.punteroDeContenidoActual.paginaWebSeleccionada = evento.target.options[evento.target.selectedIndex].text;
                    // this.obtenerPunterosParaContenido.paginaWebSeleccionada = evento.target.options[evento.target.selectedIndex].text;
             //  this.navegacionSecciones.push( evento.target.options[evento.target.selectedIndex].text);
                this.idPaginaMicrositio = parseInt(this.$store.getters.Get_SICPO_Catalogos_013PaginaMicrositio.catalogoPaginaMicrositioPasoUno);
                
                this.mostrarSelectCarrusel= false;
                this.mostrarSelectSeccion=true
                  this.mostrarSubsecciones = false;
            this.mostrarTablasDeSeccion=false;
            this.limpiarSubseccciones();
        },

         /**
         * Metodo encargado de obtener el valor del item seleccionado de la seccion raiz correspondiente al catalogo 008SeccionesDeLaPaginaWeb
         * obteniendo tambien lista con el arbol jerarquico de subsecciones. 
         * @param {object} evento [evento emitido por el catalogo]
         * @param {array} arbolSeccionesPw [arbol de secciones]
         */
        cambioTipoSeccion: function (evento,arbolSeccionesPw) {
            // console.log("EVENTO::::::::::",evento)
            // console.log("ARBOLLL:::::",arbolSeccionesPw)
                this.mostrarBotonDeAgregar = true;
                this.validarSeccionesNoValidas(evento.target.value,this.seccionPadre);          
                let tituloSeccion = evento.target.options[evento.target.selectedIndex].text;
                 this.punteroDeContenidoActual.rutaSecciones = tituloSeccion;
                this.navegacionSecciones.push(tituloSeccion);
                this.numeroFormatoSeccion = parseInt(this.$store.getters.Get_SICPO_Catalogo_FormatoDeSeccion.valor);
                this.mostrarSubsecciones = false;
                this.mostrarTablasDeSeccion=false;
                
                if(this.numeroFormatoSeccion == 32 || this.numeroFormatoSeccion == 15){
                this.mostrarSelectCarrusel= true;
                this.mostrarBotonDeAgregar=false;
                }
                else this.mostrarSelectCarrusel= false;
                if(this.numeroFormatoSeccion == 26){
                    this.subSeccionesMicrositios = this.formatearSubSecciones(arbolSeccionesPw.SeccionesQueMePertenecenMicrositio);
                 //   console.log("SUbseccionessss::::",this.subSeccionesMicrositios)
                    this.mostrarSubsecciones = true;
                    this.mostrarTablasDeSeccion=false;
                    this.mostrarBotonDeAgregar=false;
                }
                

                 this.seccionId = parseInt(this.$store.getters.Get_SICPO_Catalogo_014SeccionMicrositio.catalogoSeccionPasoUno);
              let tipoFormulario = this.identificarTipoDeFormulario(this.numeroFormatoSeccion,true);
             // console.log("tipoFormulario::::",tipoFormulario);
               this.$store.dispatch("A_SICPO_Catalogo_TipoDeFormulario",tipoFormulario);
            },
        

        formatearSubSecciones:function(elementos){
         //   console.log("formateoDeElementos",elementos)
            elementos.forEach(element => {
                var nuevoObjeto = {}
                element.nombre = element.Titulo;
                element.valor = element.SeccionesDeMicrositioId;
                
            });

       //     console.log("secciones formateadas::",elementos)
            return elementos;

        },

         formatearContenidos:function(elementos){
      //      console.log("formateoDeElementosContenidos",elementos)
            elementos.forEach(element => {
                var nuevoObjeto = {}
                element.nombre = element.TextoDelContenido.split("|")[0];
                element.valor = element.ContenidoDeMicrositioId;
                
            });

          //  console.log("secciones formateadasContenidos::",elementos)
            return elementos;

        },

        cambioSubSeccion:function(evento,objetoSeleccionado){
             this.mostrarBotonDeAgregar=false;
            if(evento.target.value != -1){
            this.mostrarTablasDeSeccion=true;
            this.tablasDeSeccion = this.formatearContenidos(objetoSeleccionado.ContenidoDeMicrositio);
            }
           

        },
        cambioTipoCarrusel:function(evento){
       //     console.log("TIPO DE CARRUSEL:::",evento)
            if( evento.target.value != null && evento.target.value != -1)
             this.mostrarBotonDeAgregar=true;
             else this.mostrarBotonDeAgregar = false;

        },


        cambioTablaMicrositio:function(evento,tablaSeleccionada){
            if(evento.target.value != -1){
                 this.mostrarBotonDeAgregar=true;
                var datosTabla = {}
                datosTabla.titulo=tablaSeleccionada.TextoDelContenido;
                datosTabla.valor = this.numeroFormatoSeccion;
                this.$store.dispatch("A_SICPO_Catalogo_FormatoDeSeccion",datosTabla);
                const valoresDelCatalogo ={
                llave: "contenidoMicrositioId",
                valor: evento.target.value }
                this.$store.dispatch("A_SICPO_Catalogo_015ContenidoMicrositio",valoresDelCatalogo);
            }else{
                 this.mostrarBotonDeAgregar=false;
            }
        },
        
        /**
         * Metodo encargado de validar que el item seleccionado de una seccion sea de un valor 
         * que se encuentra en el arbol de secciones omitiendo asi valores default (en este caso -1).
         * @param {Number} idSeccion [valor que reprenta la llave de la seccion seleccionada]
         */
        validarSeccionesNoValidas: function(idSeccion,seccionPadre) {
            const valorNoPermitido = -1;
            let indexSeccion = -1;
            let permiteSubirContenido = false;
          
            if(seccionPadre != null && seccionPadre.length > 0 && idSeccion != valorNoPermitido) {
                indexSeccion = seccionPadre.findIndex(s => s.SeccionDeLaPaginaWebId == idSeccion);
                permiteSubirContenido = (seccionPadre[indexSeccion].PermiteSubirContenido) ? true: false;
            }

            this.mostrarSeccionSeleccionada = true;
            if(idSeccion == valorNoPermitido || !permiteSubirContenido) {
                this.mostrarSeccionSeleccionada = false;
            }
            this.mostrarSeccionSeleccionada=true
        },
        /**
         * Metodo encargado de limpiar todos las subsecciones y la variables relacionadas con la logica 
         * de estas. 
         */
        limpiarSubseccciones: function() {
            this.subseccionesDePagianWeb = [];
            this.contadorSubseccion = 0;
            this.seccionPadre = [];
            this.navegacionSecciones = [];
            this.subseccionesAgregadasTmp = 0;
            this.mostrarSeccionSeleccionada = false;
             
        },
        /**
         * Metodo encargado de crear una subseccion y agregarla a la vista para que posteriormente pueda
         * ser construido de manera dinamica en la vista correspondiente al componente pasoUno. 
         * @param {Number} idSeccion [valor que reprenta la llave de la seccion seleccionada]
         * @param {Object} seccionPadre [seccion padre de la subseccion seleccionada]
         */
        agregarSubseccion: function(idSeccion,seccionPadre) {
           
            if(idSeccion != -1) {
                let subsecciones = seccionPadre.find(subseccion => subseccion.SeccionDeLaPaginaWebId == idSeccion).SeccionesQueMePertenecen;
                if(subsecciones != null && subsecciones != undefined && subsecciones.length > 0) {
                    this.seccionPadre = subsecciones;
                    let objetoSubseccion = this.construirObjetoSubseccion(subsecciones);
                    this.subseccionesDePagianWeb.push(objetoSubseccion);
                }
            }
        },
        /**
         * Metodo encargado de transformar los valores obtenidos en el arbol de subsecciones a la estructura 
         * requerida para su construccion dinamica.
         * @param {Array} listaSubsecciones [lista de subsecciones]
         * @returns {Object} objetoSubseccion [objeto contruido con la estructura de una subseccion]
         */
        construirObjetoSubseccion: function(listaSubsecciones) {
            let objetoSubseccion = {};
            let identificadorInput = 'subseccion';
            let idInputSubseccion = identificadorInput + this.contadorSubseccion;
            let keyInputSubseccion = identificadorInput + this.contadorSubseccion;
            objetoSubseccion.idDelInput = idInputSubseccion;
            objetoSubseccion.key = keyInputSubseccion;
            objetoSubseccion.subsecciones = [];
            objetoSubseccion.seccionPadre = this.seccionPadre;
            listaSubsecciones.forEach(subseccion => {
                let valoresSubseccion = {
                    valor: subseccion.SeccionDeLaPaginaWebId,
                    nombre: subseccion.NombreDeLaSeccion
                };
                objetoSubseccion.subsecciones.push(valoresSubseccion);
            });
            this.contadorSubseccion ++;
            return objetoSubseccion;
        },
         /**
         * Metodo encargado de identificar el tipo de formulario para posteriormente detectar los
         * capos que campos que requiere para ese contenido.
         * @see {@link identificarCamposParaFormulario}
         * @param {Number} id [valor correspondiente a la pagina web seleccionada]
         * @param {Number} identificarPorSeccion [valor correspondiente a la seccion seleccionada]
         * @returns {Object} camposDeFormulario [objeto con los campos requeridos para ese tipo de contenido]
         */
        identificarTipoDeFormulario: function(id,identificarPorSeccion) {
            let camposDeFormulario = this.asigarCamposPorFormato(id);          
            return camposDeFormulario;
        },
        /**
         * Metodo encargado de agregar los input actuales del formulario para posteriormente identificar caules 
         * son requeridos.
         * @see {@link asignarPrioridadACamposDeFormulario}
         * @param {Number} id [valor correspondiente a la pagina web seleccionada]
         * @param {Number} identificarPorSeccion [valor correspondiente a la seccion seleccionada]
         * @returns {Object} camposNecesariosFormulario [objeto con los campos requeridos para ese tipo de contenido]
         */
        identificarCamposParaFormulario: function(id,identificarPorSeccion) {
            let camposDeFormulario = ['textoDelContenido','textoDelVinculo','archivosDeContenido','vinculo','titulo','imagenDeContenido', 'opcionesComunicadoUrgente', 'fechaDePublicacion','listaDeArchivos','rangoPresidente','nombrePresidente','archivoConVinculo','disposicionEspecial','catalogoPoderes','imagenesObligaciones'];
            let camposNecesariosFormulario = {};
            camposNecesariosFormulario['tipoDeFormulario'] = this.paginaRequiereComunicado(id)? 'comunicado': 'comun';
            for(let i=0;i<camposDeFormulario.length; i++) {
                let llave = camposDeFormulario[i];
                let valoresDeCampo = this.asignarPrioridadACamposDeFormulario(id,llave,identificarPorSeccion);
                camposNecesariosFormulario[llave] = valoresDeCampo;
            }
            return camposNecesariosFormulario;
        },

        asigarCamposPorFormato(numeroFormato){
            let camposNecesariosFormulario = {};
            switch(numeroFormato){
                    case formatos.TiposFormatoMicrositios.RouterHover:
                        camposNecesariosFormulario["RutaDelArchivo"]=true;                      
                        camposNecesariosFormulario["TextoDelVinculo"]=true;                        
                        camposNecesariosFormulario["TamanoDeLaColumna"]=true;
                        camposNecesariosFormulario["FechaPublicacion"]=true;
                        camposNecesariosFormulario["AbrirEnVisor"]=true; 
                        camposNecesariosFormulario["RutaDelVideo"]=false;
              
                        camposNecesariosFormulario["TextoDelVinculoRequerido"]=true;   
                        camposNecesariosFormulario["RutaDelArchivoRequerido"]=true;
                        camposNecesariosFormulario["FechaPublicacionRequerido"]=false;

                        break;
                    case formatos.TiposFormatoMicrositios.CarruselYTexto:
                         camposNecesariosFormulario["RutaDelVideo"]=false;
                             
                        camposNecesariosFormulario["RutaDeImagen"]=true;
                        camposNecesariosFormulario["TituloCarruselTexto"]=true;
                        camposNecesariosFormulario["TextoDelContenidoCarrusel"]=true;
                        camposNecesariosFormulario["FechaPublicacion"]=true;
                        camposNecesariosFormulario["SeleccionaImagenOTexto"]=true,
                        camposNecesariosFormulario["ApareceEnComunicados"] = true;
                         camposNecesariosFormulario["TituloComunicado"] = true;


                         camposNecesariosFormulario["FechaPublicacionRequerido"]=false;

                         
                        break;
                    case formatos.TiposFormatoMicrositios.Imagen:
                         camposNecesariosFormulario["RutaDelVideo"]=false;
                        camposNecesariosFormulario["RutaDelArchivo"]=true;
                        camposNecesariosFormulario["RutaDeImagen"]=true;
                        camposNecesariosFormulario["TamanoDeLaColumna"]=false;
                        camposNecesariosFormulario["FechaPublicacion"]=true;
                         camposNecesariosFormulario["AbrirEnVisor"]=true;
                        //  camposNecesariosFormulario["ApareceEnComunicados"] = true;
                         camposNecesariosFormulario["TituloComunicado"] = true;

                         camposNecesariosFormulario["FechaPublicacionRequerido"]=false;
                         camposNecesariosFormulario["RutaDeImagenRequerido"]=true;   
                        break;
                    case formatos.TiposFormatoMicrositios.Video:
                        camposNecesariosFormulario["TamanoDeLaColumna"]=true;
                        camposNecesariosFormulario["RutaDelVideo"]=true;
                        camposNecesariosFormulario["RutaDeImagen"]=false;                        
                        camposNecesariosFormulario["TextoDelContenido"]=true;
                        camposNecesariosFormulario["FechaPublicacion"]=true; 



                         camposNecesariosFormulario["RutaDeVideoRequerido"]=true;
                         camposNecesariosFormulario["TextoDelContenidoRequerido"]=false;
                         camposNecesariosFormulario["TextoDelVinculoRequerido"]=false;
                         camposNecesariosFormulario["FechaPublicacionRequerido"]=false;
                         camposNecesariosFormulario["RutaDeImagenRequerido"]=false; 
                         
                        break;
                    case formatos.TiposFormatoMicrositios.HomeMicrositios:
                        break;
                    case formatos.TiposFormatoMicrositios.CajaConVinculo:
                         camposNecesariosFormulario["RutaDelVideo"]=false;
                        camposNecesariosFormulario["TamanoDeLaColumna"]=true;
                        camposNecesariosFormulario["RutaDelArchivo"]=true;
                        camposNecesariosFormulario["TextoDelVinculo"]=true;
                        camposNecesariosFormulario["FechaPublicacion"]=true;
                         camposNecesariosFormulario["AbrirEnVisor"]=true;
                        // camposNecesariosFormulario["ApareceEnComunicados"] = true;
                         camposNecesariosFormulario["TituloComunicado"] = true;

                         camposNecesariosFormulario["RutaDelArchivoRequerido"]=true;
                         camposNecesariosFormulario["TextoDelVinculoRequerido"]=true;
                         camposNecesariosFormulario["FechaPublicacionRequerido"]=false;
                         camposNecesariosFormulario["RutaDeImagenRequerido"]=false; 
                         camposNecesariosFormulario["TextoDelContenidoRequerido"]=false; 
                        break;
                    case formatos.TiposFormatoMicrositios.ImagenConVinculo:
                         camposNecesariosFormulario["RutaDelVideo"]=false;
                        camposNecesariosFormulario["TamanoDeLaColumna"]=true;
                        camposNecesariosFormulario["RutaDelArchivo"]=true;
                        camposNecesariosFormulario["RutaDeImagen"]=true;
                        camposNecesariosFormulario["TextoDelVinculo"]=true;
                        camposNecesariosFormulario["FechaPublicacion"]=true;
                         camposNecesariosFormulario["AbrirEnVisor"]=true;
                        //  camposNecesariosFormulario["ApareceEnComunicados"] = true;
                         camposNecesariosFormulario["TituloComunicado"] = true;
                         camposNecesariosFormulario["TextoDelContenido"]=true;

                         camposNecesariosFormulario["RutaDeImagenRequerido"]=true; 
                         camposNecesariosFormulario["RutaDelArchivoRequerido"]=false;
                         camposNecesariosFormulario["TextoDelVinculoRequerido"]=false;
                         camposNecesariosFormulario["FechaPublicacionRequerido"]=false;
                         
                          
                        break;
                    case formatos.TiposFormatoMicrositios.ImagenTextoLinkAlFinal:
                         camposNecesariosFormulario["RutaDelVideo"]=false;
                        camposNecesariosFormulario["TamanoDeLaColumna"]=true;
                        camposNecesariosFormulario["RutaDelArchivo"]=true;
                        camposNecesariosFormulario["RutaDeImagen"]=true;
                        camposNecesariosFormulario["TextoDelVinculo"]=true;
                        
                        camposNecesariosFormulario["TextoDelContenidoTitulo"]=true;  

                        camposNecesariosFormulario["TextoDelContenido"]=true;
                        camposNecesariosFormulario["FechaPublicacion"]=true;
                         camposNecesariosFormulario["AbrirEnVisor"]=true;
                        //  camposNecesariosFormulario["ApareceEnComunicados"] = true;
                         camposNecesariosFormulario["TituloComunicado"] = true;

                         camposNecesariosFormulario["RutaDelArchivoRequerido"]=true;
                         camposNecesariosFormulario["TextoDelVinculoRequerido"]=true;
                         camposNecesariosFormulario["FechaPublicacionRequerido"]=false;
                         camposNecesariosFormulario["RutaDeImagenRequerido"]=true; 
                         camposNecesariosFormulario["TextoDelContenidoRequerido"]=true;
                         camposNecesariosFormulario["TextoDelContenidoTituloRequerido"]=true;  

                        break;
                    case formatos.TiposFormatoMicrositios.ImagenConTexto:
                        break;
                    case formatos.TiposFormatoMicrositios.Texto:
                         camposNecesariosFormulario["RutaDelVideo"]=false;
                        camposNecesariosFormulario["TextoDelContenido"]=true; 
                        camposNecesariosFormulario["TamanoDeLaColumna"]=true;
                        camposNecesariosFormulario["FechaPublicacion"]=true; 

                         camposNecesariosFormulario["RutaDelArchivoRequerido"]=false;
                         camposNecesariosFormulario["TextoDelVinculoRequerido"]=false;
                         camposNecesariosFormulario["FechaPublicacionRequerido"]=false;
                         camposNecesariosFormulario["RutaDeImagenRequerido"]=false; 
                         camposNecesariosFormulario["TextoDelContenidoRequerido"]=true;
                         camposNecesariosFormulario["TextoDelContenidoTituloRequerido"]=false; 

                        break;
                    case formatos.TiposFormatoMicrositios.ListaTexto:
                         camposNecesariosFormulario["RutaDelVideo"]=false;
                        camposNecesariosFormulario["TextoDelContenido"]=true; 
                        camposNecesariosFormulario["TamanoDeLaColumna"]=true;
                        camposNecesariosFormulario["FechaPublicacion"]=true; 


                        camposNecesariosFormulario["RutaDelArchivoRequerido"]=false;
                         camposNecesariosFormulario["TextoDelVinculoRequerido"]=false;
                         camposNecesariosFormulario["FechaPublicacionRequerido"]=false;
                         camposNecesariosFormulario["RutaDeImagenRequerido"]=false; 
                         camposNecesariosFormulario["TextoDelContenidoRequerido"]=true;
                         camposNecesariosFormulario["TextoDelContenidoTituloRequerido"]=false; 
                        break;
                    case formatos.TiposFormatoMicrositios.Contacto:
                        camposNecesariosFormulario["RutaDelVideo"]=false;
                        camposNecesariosFormulario["TextoDelContenido"]=false;
                         camposNecesariosFormulario["TextoDelVinculo"]=true;                                     
                        // camposNecesariosFormulario["ApareceEnComunicados"] = true;
                        camposNecesariosFormulario["TituloComunicado"] = true;
                        camposNecesariosFormulario["RutaDelArchivo"]=true;
                         camposNecesariosFormulario["AbrirEnVisor"]=true;
                         camposNecesariosFormulario["Columnas"]=true;



                        camposNecesariosFormulario["RutaDelArchivoRequerido"]=true;
                         camposNecesariosFormulario["TextoDelVinculoRequerido"]=true;
                         camposNecesariosFormulario["FechaPublicacionRequerido"]=false;
                         camposNecesariosFormulario["RutaDeImagenRequerido"]=false; 
                         camposNecesariosFormulario["TextoDelContenidoRequerido"]=false;
                         camposNecesariosFormulario["TextoDelContenidoTituloRequerido"]=false; 
                         camposNecesariosFormulario["ColumnasRequerido"] = true;
                        //  camposNecesariosFormulario["RutaDelVideo"]=false;
                        //  camposNecesariosFormulario["FechaPublicacion"]=true;            
                        //  camposNecesariosFormulario["TextoDelContenidoTitulo"]=true;
                          
                        //  camposNecesariosFormulario["ArchivosTituloDelDato"]=true;
                        //    camposNecesariosFormulario["ArchivoAdicional"]=true;
                        //  camposNecesariosFormulario["ArchivosTextoDeDescripcion"]=true;


                        //  camposNecesariosFormulario["RutaDelArchivoRequerido"]=false;
                        //  camposNecesariosFormulario["TextoDelVinculoRequerido"]=false;
                        //  camposNecesariosFormulario["FechaPublicacionRequerido"]=false;
                        //  camposNecesariosFormulario["RutaDeImagenRequerido"]=false; 
                        //  camposNecesariosFormulario["TextoDelContenidoRequerido"]=true;
                        //  camposNecesariosFormulario["ListaContactosRequerido"]=true;
                        //  camposNecesariosFormulario["TextoDelContenidoTituloRequerido"]=false; 
                           
                        break;
                    case formatos.TiposFormatoMicrositios.MapaContacto:
                         camposNecesariosFormulario["RutaDelVideo"]=false;
                        camposNecesariosFormulario["FechaPublicacion"]=true;            
                        
                         camposNecesariosFormulario["RutaVinculo"]=true;                      
                         camposNecesariosFormulario["ArchivosTituloDelDato"]=true;
                        
                         camposNecesariosFormulario["ArchivosTextoDeDescripcion"]=true;
                         camposNecesariosFormulario["TextoDelContenidoTitulo"]= true;
                         camposNecesariosFormulario["EsLink"]= true;


                         camposNecesariosFormulario["ListaContactosRequerido"]=true;                       
                         camposNecesariosFormulario["FechaPublicacionRequerido"]=false;
                         camposNecesariosFormulario["TituloDelContenidoRequerido"]=true;
                         camposNecesariosFormulario["RutaVinculoRequerido"]=false; 

                        break;
                    case formatos.TiposFormatoMicrositios.VinculosHover:
                         camposNecesariosFormulario["RutaDelVideo"]=false;
                        camposNecesariosFormulario["RutaDelArchivo"]=true;
                        camposNecesariosFormulario["TextoDelVinculo"]=true;
                        camposNecesariosFormulario["TamanoDeLaColumna"]=true;
                        camposNecesariosFormulario["FechaPublicacion"]=true;
                         camposNecesariosFormulario["AbrirEnVisor"]=true;

                        camposNecesariosFormulario["RutaDelArchivoRequerido"]=true;
                         camposNecesariosFormulario["TextoDelVinculoRequerido"]=true;
                         camposNecesariosFormulario["FechaPublicacionRequerido"]=false;
                         camposNecesariosFormulario["RutaDeImagenRequerido"]=false; 
                         camposNecesariosFormulario["TextoDelContenidoRequerido"]=false;
                         camposNecesariosFormulario["TextoDelContenidoTituloRequerido"]=false; 
                        break;
                    case formatos.TiposFormatoMicrositios.TablaDescripcionYLink:
                         camposNecesariosFormulario["RutaDelVideo"]=false;
                        camposNecesariosFormulario["TextoDelContenido"]=false;
                         camposNecesariosFormulario["TextoDelVinculo"]=true;                                     
                        // camposNecesariosFormulario["ApareceEnComunicados"] = true;
                        camposNecesariosFormulario["TituloComunicado"] = true;
                        camposNecesariosFormulario["RutaDelArchivo"]=true;
                         camposNecesariosFormulario["AbrirEnVisor"]=true;
                         camposNecesariosFormulario["Columnas"]=true;



                        camposNecesariosFormulario["RutaDelArchivoRequerido"]=false;
                         camposNecesariosFormulario["TextoDelVinculoRequerido"]=false;
                         camposNecesariosFormulario["FechaPublicacionRequerido"]=false;
                         camposNecesariosFormulario["RutaDeImagenRequerido"]=false; 
                         camposNecesariosFormulario["TextoDelContenidoRequerido"]=false;
                         camposNecesariosFormulario["TextoDelContenidoTituloRequerido"]=false; 

                        break;
                     case formatos.TiposFormatoMicrositios.ContenidoConTabla:
                           camposNecesariosFormulario["RutaDelVideo"]=false;
                        camposNecesariosFormulario["TextoDelContenido"]=false;
                         camposNecesariosFormulario["TextoDelVinculo"]=true;                                     
                        // camposNecesariosFormulario["ApareceEnComunicados"] = true;
                        camposNecesariosFormulario["TituloComunicado"] = true;
                        camposNecesariosFormulario["RutaDelArchivo"]=false;
                         camposNecesariosFormulario["AbrirEnVisor"]=false;
                         camposNecesariosFormulario["Columnas"]=true;
                         camposNecesariosFormulario["TablaPorContenido"]=true; 
                        camposNecesariosFormulario["RutaDelArchivoRequerido"]=false;
                         camposNecesariosFormulario["TextoDelVinculoRequerido"]=true;
                         camposNecesariosFormulario["FechaPublicacionRequerido"]=false;
                         camposNecesariosFormulario["RutaDeImagenRequerido"]=false; 
                         camposNecesariosFormulario["TextoDelContenidoRequerido"]=false;
                         camposNecesariosFormulario["TextoColumnasRequerido"]=true;
                         camposNecesariosFormulario["TextoDelContenidoTituloRequerido"]=false; 
                         break;

                     case formatos.TiposFormatoMicrositios.TablaDeTexto:
                          camposNecesariosFormulario["RutaDelVideo"]=false;
                        
                         camposNecesariosFormulario["TextoDelContenido"]=false;
                         camposNecesariosFormulario["TituloDeSeccion"]=false;
                         camposNecesariosFormulario["Columnas"]=true 
                         camposNecesariosFormulario["FechaPublicacion"]=true;

                         camposNecesariosFormulario["TextoColumnasRequerido"]=true;
                         camposNecesariosFormulario["TextoDelVinculoRequerido"]=false;
                         camposNecesariosFormulario["FechaPublicacionRequerido"]=false;
                         camposNecesariosFormulario["RutaDeImagenRequerido"]=false; 
                     

                        break;
                     case formatos.TiposFormatoMicrositios.CarruselSimple:
                          camposNecesariosFormulario["RutaDelVideo"]=false;
                         camposNecesariosFormulario["TextoDelVinculo"]=false;         
                         camposNecesariosFormulario["AbrirEnVisor"]=true;
                            camposNecesariosFormulario["RutaDelArchivo"]=false;
                           camposNecesariosFormulario["RutaDeImagen"]=true;
                        camposNecesariosFormulario["TituloCarrusel"]=true;
                        camposNecesariosFormulario["TextoDelContenido"]=true;
                        camposNecesariosFormulario["FechaPublicacion"]=true; 
                        camposNecesariosFormulario["ArchivoAdicional"]=true;
                        // camposNecesariosFormulario["ApareceEnComunicados"] = true;
                         camposNecesariosFormulario["TituloComunicado"] = true;

                         camposNecesariosFormulario["RutaDeImagenRequerido"]=true;                         
                         camposNecesariosFormulario["FechaPublicacionRequerido"]=false;
                        
                        break;
                    case formatos.TiposFormatoMicrositios.Pestanas:
                         camposNecesariosFormulario["RutaDelVideo"]=false;
                         camposNecesariosFormulario["TextoDelVinculo"]=true;                                     
                        // camposNecesariosFormulario["ApareceEnComunicados"] = true;
                        camposNecesariosFormulario["TituloComunicado"] = true;
                        camposNecesariosFormulario["RutaDelArchivo"]=true;
                        camposNecesariosFormulario["AbrirEnVisor"]=true;
                        camposNecesariosFormulario["Columnas"]=true;
                          camposNecesariosFormulario["FechaPublicacion"]=true; 



                        camposNecesariosFormulario["RutaDelArchivoRequerido"]=false;
                         camposNecesariosFormulario["TextoDelVinculoRequerido"]=false;
                         camposNecesariosFormulario["FechaPublicacionRequerido"]=true;
                         camposNecesariosFormulario["RutaDeImagenRequerido"]=false; 
                         camposNecesariosFormulario["TextoDelContenidoRequerido"]=false;
                         camposNecesariosFormulario["TextoDelContenidoTituloRequerido"]=false; 

                        break;
                        case formatos.TiposFormatoMicrositios.VinculoModalMicrositio:
                             camposNecesariosFormulario["RutaDelVideo"]=false;
                            camposNecesariosFormulario["TextoDelContenido"]=true;
                             camposNecesariosFormulario["TextoDelVinculo"]=true;  
                               camposNecesariosFormulario["TextoDelVinculoRequerido"]=true; 
                               camposNecesariosFormulario["TextoDelContenidoRequerido"]=true;
                            break;
                         
   
            }
            return camposNecesariosFormulario;
        },
       
        /**
         * Metodo encargado de buscar un id dentro de una lisa, en este caso saber si un campo
         * del formulario es requerido.
         * @see {@link asignarPrioridadACamposDeFormulario}
         * @param {Number} idAComparar [valor correspondiente a la pagina web o seccion seleccionada]
         * @param {Number} listaDeId [id de paginasWeb o secciones que son comunicados]
         * @returns {boolean} esRequerido [indica si el input es requerido(true) o no(false)]
         */
        compararListaDeId: function(idAComparar, listaDeId) {
            let esRequerido = false;
            listaDeId.forEach((id)=>{
                if(id == idAComparar){
                    esRequerido = true;
                }
            });
            return esRequerido;
        },
        /**
         * Metodo encargado para saber si el contenido es comunicado o no.
         * @see {@link asignarPrioridadACamposDeFormulario}
         * @param {Number} id [valor correspondiente a la pagina web]
         * @returns {boolean} esComunicado [indica si es comunicado(true) o no(false)]
         */
        paginaRequiereComunicado: function(id) {
            let comunicadosId = [19,20,21];
            let esComunicado = false;
            comunicadosId.forEach((comunicadoId)=>{
                if(comunicadoId == id){
                    esComunicado = true;
                }
            });
            return esComunicado;
        }
      },
      created(){
          this.$store.dispatch("A_SICPO_PaginaWeb_AltaDeContenido_establecerMostrarFormularios",false);
          this.$store.dispatch("A_SICPO_PaginaWeb_AltaDeContenido_establecerMostrarPasoTres",false);
          this.$store.dispatch("A_SICPO_Catalogo_001PaginaInicio",{llave: 'catalogoPaginaPasoUno',valor: -1});
         
      },
      computed:{
          obtenerCatalogoSeccion() {
             return this.$store.getters.Get_SICPO_Catalogos_013PaginaMicrositio
          },
          obtenerCatalogoPaginasDeMicrositio(){           
             
              return this.$store.getters.Get_SICPO_Catalogos_001PaginaInicio
          },
          obtenerContenidoMicrositio(){           
              return this.$store.getters.Get_SICPO_Catalogo_014SeccionMicrositio
          }
      }
  }
</script>
<style scoped>
.btn-primary{
    background-color: var(--verde-pj-100);
}
.btn-primary:hover{
    background-color: var(--verde-pj);
}


.tipoDePagina_DIV {
    display: flex;
    
}
#subidordearchivos_div {
    text-align: center
}
.vr {
    width:1px;
    background-color: white;
    margin-left: 15px;
}

.secciones {
    margin-top: 20px;
}

.subscciones {
    padding:0; 
    margin: 0;
    margin-top: 6px;
}
h5, h6{
        user-select: none;
}

.desabilitar-div-pasoUno {
    pointer-events: none;
    opacity: 0.4;
}

#pasoUno-aviso-secciones {
     padding: 1em;
     background-color: #26272b;
     border: 1px solid #5c5959;
     border-radius: 8px;
     margin-bottom: 1em;;
 }

</style>



// WEBPACK FOOTER //
// src/components/SICPO/Micrositios/Comun/CFormularioPasoUnoMicrositio.vue